
import Developer from "../../components/Developer.js"

import DATA from "../data/_entity.json"; // assert { type: "json" }

import footerimg from "../../assets/images/footer.png";
import socialIcons from "../../assets/icons/socialIcons.js";

import "./footer.css";


const Footer = ({ APPDATA }) => {

  return (
    <>
      <div className="footer-container">
        <img className="footer-img" src={footerimg} alt="footer" />
        <div className="footer-ul">
          <ul >
            {(Object.keys(DATA.entity.contact.Social).length !== 0) ? (
              Object.entries(DATA.entity.contact.Social).map((key) => {

                let source = socialIcons[`${key[0]}`];
                return (
                  <li key={key[0]} className="button" title={source.title}>
                    <a
                      href={key[1]}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icons"
                    >
                      {source}
                    </a>
                  </li>
                )
              })
            ) : null}
          </ul>
          <br />
          Copyright 2023(c). All Rights Reserved.
          <Developer APPDATA={APPDATA} />
        </div>
      </div >
    </>
  );
};

export default Footer;
